import React, { useEffect } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import Tooltip from "@mui/material/Tooltip";
import { useMsal } from "@azure/msal-react";
import receipt from "../assets/receipt.svg";
import axios from "axios";
import pdf from "../assets/pdf.svg";
import PopupExpenseEdit from "./popupExpense/PopupExpenseEdit";
import SettingsIcon from '@mui/icons-material/Settings';

function ExpenseEntry({ expense, truncate, index }) {
  const [openAddExpense, setOpenAddExpense] = React.useState(false);
  const { instance, accounts } = useMsal();
  const [file, setFile] = React.useState(null);
  const name = accounts[0].name;
  const format = (text) => {
    if (truncate) {
      return text.substring(0, 20) + "...";
    }
    return text.substring(0, 40);
  };
  const handleDownload = async () => {
    try {
      // Prefer using the exact blob path you store. Fallback to your pattern.
      const blobPath = `receipt-${expense.ExpenseID}.pdf`;

      const { data } = await axios.get('/api-dev/expenses/getReceipt', {
        params: { blob: blobPath, container: 'receipts', ttl: 300 }
      });

      // Easiest: open the SAS URL (browser downloads if Content-Type lets it)
      // window.open(data.url, '_blank');

      // Or: force a download with a nice filename
      const resp = await fetch(data.url);
      if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
      const fileBlob = await resp.blob();

      // Try filename from headers; fallback to last path segment
      let fileName = 'download';
      const cd = resp.headers.get('content-disposition');
      if (cd) {
        const m = /filename\*?=(?:UTF-8'')?["']?([^"';]+)["']?/i.exec(cd);
        if (m?.[1]) fileName = decodeURIComponent(m[1]);
      }
      if (fileName === 'download') {
        const clean = data.url.split('?')[0];
        const last = clean.substring(clean.lastIndexOf('/') + 1);
        if (last) fileName = decodeURIComponent(last);
      }

      const a = document.createElement('a');
      a.href = URL.createObjectURL(fileBlob);
      a.download = `${expense.InternalInvoiceNumber}_${expense.Note}_${expense.ProjectID}_${expense.ExpenseDate.substring(0,10)}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(a.href);
    } catch (err) {
      console.error('Download error:', err);
    }
  };
  const handleEdit = async () => {
    try{
      const blobPath = `receipt-${expense.ExpenseID}.pdf`;

      const { data } = await axios.get('/api-dev/expenses/getReceipt', {
        params: { blob: blobPath, container: 'receipts', ttl: 300 }
      });
      // set file as the ffile object
      const resp = await fetch(data.url);
      if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
      const fileBlob = await resp.blob();
      // Convert blob to File
      const fileName = `receipt-${expense.ExpenseID}.pdf`;
      const fileObj = new File([fileBlob], fileName, { type: fileBlob.type || 'application/pdf' });
      setFile(fileObj);
      setTimeout(() => setOpenAddExpense(true), 0);
    } catch(err) {
      console.error('Download error:', err);
    }
  }

  return (
    <>
      <Draggable
        key={expense.ExpenseID}
        draggableId={expense.ExpenseID + ""}
        index={index}
      >
        {(provided) => (
          
            <div
              className="expense-container"
              ref={provided.innerRef}
              {...provided.draggableProps}
              {...provided.dragHandleProps}
            >
              <PopupExpenseEdit
                setOpenPopup={setOpenAddExpense}
                candidates={[]}
                openPopup={openAddExpense}
                internalInvoice={expense.InternalInvoiceNumber}
                notes={expense.Note}
                date={expense.ExpenseDate}
                expenseid={expense.ExpenseID}
                netAmount={expense.Input}
                taxAmount={expense.TaxAmount}
                taxRate={expense.TaxRate}
                fileContent={file}
                staffer={expense.EntityStaffer}
              />
              <Tooltip
            title={
              (expense.InternalInvoiceNumber
                ? expense.InternalInvoiceNumber + ": "
                : "") +
              expense.Note +
              (expense.ExpenseDate
                ? " [" + expense.ExpenseDate.substring(0, 10) + "]"
                : "")
            }
            placement="bottom"
          >
              <div className="expense-name" style={{ overflow: "hidden" }}>
                <div style={{ width: "100%", height: "17px" }}>
                  {expense.ExpenseID} ////
                  {(expense.InternalInvoiceNumber
                    ? expense.InternalInvoiceNumber + ": "
                    : "") +
                    expense.Note +
                    (expense.ExpenseDate
                      ? " [" + expense.ExpenseDate.substring(0, 10) + "]"
                      : "")}
                </div>
              </div>
              </Tooltip>
              <div className="expense-value">
                {expense.Input.toFixed(2)
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
              </div>
              {expense.ExpenseReceipt && <button
                onClick={() => handleDownload()}
                className="download-button"
              >
                <img className="download-icon" src={pdf} alt="#" />
              </button>}
              {/* <button
                onClick={() => handleEdit()}
                className="download-button"
              >
                <SettingsIcon />
              </button> */}
            </div>
        )}
      </Draggable>
    </>
  );
}

export default ExpenseEntry;
